<template>
  <ValidationObserver ref="observer" v-slot="{ handleSubmit }" slim>
    <b-alert variant="info" show dismissible>
      {{ $t('event_registrierung.passwort_reset.alert_global_login') }}
    </b-alert>
    <b-form @submit.prevent="handleSubmit(login)">
      <ValidationProvider
        :name="$t('event_registrierung.passwort_reset.label_username')"
        rules="required"
        v-slot="validationContext"
      >
        <b-form-group
          id="fieldset-username"
          :label="$t('event_registrierung.passwort_reset.label_username') + ' *'"
          label-for="input-username"
        >
          <b-form-input
            id="input-username"
            v-model="form.username"
            size="sm"
            :state="getValidationState(validationContext)"
            aria-describedby="feedback-username"
          ></b-form-input>
          <b-form-invalid-feedback id="feedback-username">{{
            validationContext.errors[0]
          }}</b-form-invalid-feedback>
        </b-form-group>
        <b-form-group v-if="message.show" class="mb-0">
          <b-alert :variant="message.type ? message.type : 'info'" show>{{
            message.msg
          }}</b-alert>
        </b-form-group>
      </ValidationProvider>
      <b-button
        :to="`/${$i18n.locale}/veranstalter/login`"
        variant="light"
        class="mr-2"
        >{{ $t('event_registrierung.passwort_reset.back') }}</b-button
      >
      <b-button type="submit" variant="primary">{{ $t('event_registrierung.passwort_reset.reset') }}</b-button>
    </b-form>
    <div
      v-if="displayPageLoader"
      id="pageLoader"
      class="d-flex justify-content-center align-items-center"
    >
      <b-spinner label="Loading..."></b-spinner>
    </div>
  </ValidationObserver>
</template>

<script>
import {
  ValidationProvider,
  ValidationObserver,
} from "vee-validate/dist/vee-validate.full";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      form: {
        username: ""
      },
      message: {
        show: false,
        type: "",
        msg: "",
      },
      displayPageLoader: false,
      debugLoginCorrect: true,
    };
  },
  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    resetFormMessage() {
      this.message.show = false;
      this.message.type = "";
      this.message.msg = "";
    },
    resetFormData() {
      this.form.username = "";
    },
    login() {
      this.resetFormMessage();
      this.displayPageLoader = true;
      // Sende formular daten an api
      this.$store
        .dispatch("veranstalter/loginReset", this.form.username)
        .then(() => {
          this.message.show = true;
          this.message.type = "success";
          this.message.msg = this.$t(
            "event_registrierung.passwort_reset.form_success"
          );
          setTimeout(() => {
            this.$router.push(
              "/" + this.$i18n.locale + "/veranstalter/login"
            );
          }, 5000);
        })
        .catch((err) => {
          var errorCode = '';

          try {
            errorCode = err.response.data.errorCode;
          } catch (error) {
            errorCode = '';
          }

          if (errorCode == 'USERNOTFOUNDFORLOGIN') {
            this.message.msg = this.$t("event_registrierung.passwort_reset.user_not_found");
          } else {
            this.message.msg = this.$t("event_registrierung.passwort_reset.form_fail");
          }

          this.message.type = "danger";
          this.message.show = true;

        })
        .then(() => {
          this.displayPageLoader = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
#pageLoader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(239, 239, 239, 0.6);
}
</style>